const zhCN = {
  tabRepeatingCard: '门禁卡重复',
  tabRepeatingId: '证件号重复',

  repeatingDataList: '重复数据列表',
  repeatingPersonList: '重复人员列表',

  listDataNumber: '重复号码',
  listDataAmount: '重复号码',
  listDataOperation: '操作',

  listPersonName: '姓名',
  listPersonOrganization: '所属组织',
  listPersonPhone: '手机号',
  listPersonOperation: '操作',

  requestRepeatingFail: '获取重复数据失败！',
  requestRepeatPersonFail: '获取重复人员失败！',

  listCheckBtn: '查看',
  listModifyBtn: '修改'
}
const enUS = {
  tabRepeatingCard: 'Repeating Card',
  tabRepeatingId: 'Repeating Id',

  repeatingDataList: 'Repeating Data',
  repeatingPersonList: 'Repeating Person',

  listDataNumber: 'Repeating Number',
  listDataAmount: 'Amount',
  listDataOperation: 'Operation',

  listPersonName: 'Name',
  listPersonOrganization: 'Organization',
  listPersonPhone: 'Phone',
  listPersonOperation: 'Operation',

  requestRepeatingFail: 'Request repeating data failed!',
  requestRepeatPersonFail: 'Request repeating person failed!',

  listCheckBtn: 'Check',
  listModifyBtn: 'Modify'
}

export default { zhCN, enUS }